<template>
  <div class="row">
    <div class="col-md-12">
      <transition enter-active-class="fadeIn" leave-active-class="fadeOut">
        <div :class="`alert alert-danger fade show`">
          <span>
            <i class="fa fa-warning warning" />
            <span>Your available disc space is low for the plan: {{ alertDetails.domain }}.
              <span v-if="showLink">
                Please <router-link :to="{ name: 'viewDetails', params: { index: encryptIndex( getFirstActiveAccountIndex() ) }, query: { tab: 'diskspace'} } ">click here</router-link> to check your usage details
              </span>
            </span>
          </span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import AES from "crypto-js/aes";

export default {
  name: "DiskSpaceAlert",
  props: {
    showLink: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    alertDetails() {
      return this.$store.getters["alert/getAlertDetails"];
    },
    hostingAccounts() {
      return this.$store.getters["hosting/accountsOrdered"];
    },
    aesSecret() {
      return this.$store.getters["crypto/aesSecret"];
    }
  },
  methods: {
    encryptIndex(index) {
      return AES.encrypt(index, this.aesSecret).toString()
    },
    getFirstActiveAccountIndex () {
      let firstActiveAccountIndex = -1;
      for (let index in this.hostingAccounts){
        if(this.hostingAccounts[index].status === 'active') {
          firstActiveAccountIndex = index;
          break;
        }
      }
      return firstActiveAccountIndex;
    }
  }
}
</script>

<style scoped>
.warning {
  font-size: 25px;
  margin-right: 10px;
}
</style>
